import React,{useState,useEffect} from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import PublicLayout from "layouts/public-layout";

import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { flattenMessages } from 'lang/utils.js';

import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, PUBLIC_PREFIX_PATH } from 'configs/AppConfig'
import useBodyClass from 'hooks/useBodyClass';
import axios from "axios";

let dataEscuela = JSON.parse(localStorage.getItem('dataEscuela'));


function RouteInterceptor({ activo, children, isAuthenticated, ...rest }) {
  
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated && activo == 2 ? (
          children
        ) : 
        isAuthenticated && activo == 1 ? 
        <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH+'/first-login',  
            }}
        />:
        isAuthenticated && activo == 10 ? 
        <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH+'/verify-email',  
            }}
        />
        :
        (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH+'/login',
              search: location.pathname !== APP_PREFIX_PATH ? `?next=${encodeURIComponent(location.pathname)}` : false ,
              state: { 
                from: location.pathname }
            }}
          />
         
        )
      }
    />
  );
}

export const Views = (props) => {
  const { locale, token, location, direction, userData } = props;
  const currentAppLocale = AppLocale[locale];
  const [currentAppLocaleMessages, setLocaleData] = useState(null); // Carga en inglés por defecto



  useEffect(() => {
    // Hacer una solicitud GET al servidor para obtener el archivo de traducción
    // https://api.facturasiempre.com//files/public/109/46948J4J6GL34TJ5IHG8G548

    axios.get(`https://api.facturasiempre.com//api/sistema/translates/es_MX.json?i=${dataEscuela && dataEscuela.id}`)
      .then(response => {
        setLocaleData(response.data); // Almacena los datos de traducción en el estado
      })
      .catch(error => {
        console.error('Error al obtener el archivo de traducción:', error);
      });
  }, [dataEscuela]); // El [] asegura que se haga la solicitud solo una vez al montar el componente

  useBodyClass(`dir-${direction}`);
  return (
    currentAppLocaleMessages && <IntlProvider
      locale={currentAppLocale.locale}
      messages={flattenMessages(currentAppLocale.messages) }>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={PUBLIC_PREFIX_PATH}>
            <PublicLayout direction={direction} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <RouteInterceptor path={APP_PREFIX_PATH} activo={userData ? userData.activo : null} isAuthenticated={token}>
            <AppLayout direction={direction} location={location}/>
          </RouteInterceptor>
          {/* {ERROR 404 GENERAL REDIRECCIÓN} */}
          <Redirect path="*" to={APP_PREFIX_PATH} />
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}


const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } =  theme;
  const { token, userData } = auth;

  return { locale, direction, token, userData }
};

export default withRouter(connect(mapStateToProps)(Views));